import { createStore } from "vuex";
import axios           from "axios";


axios.defaults.headers.common = {
    'X-Requested-With' : 'XMLHttpRequest',
    'X-CSRF-TOKEN'     : document.querySelector( 'meta[name="csrf-token"]' ).getAttribute( 'content' ),
};

let state =
        {
            authenticated : false,
            currentUser   : null,
            currentUserId : null,
            token         : null,

            audienceMode : "jeunes",

            mainContentType : '',
            mainContentId   : 0,
            reactionsOnly   : false,
            comments        : [],
            newComments     : [],

            userReactions : [],
            relatedCachedOn: 0,

            showComments : true,

            reportModalOpen        : false,
            reportCurrentCommentId : 0,
            reportCurrentReasonId  : 0,

            doLiveRefresh               : false,
            liveRefreshFrequency        : 30,
            isCurrentlyUpdatingComments : false,
        };

let getters =
        {
            comments ( state )
            {
                return state.comments;
            },

            isAutheticated ( state )
            {
                return typeof state.authenticated !== 'undefined' && state.authenticated;
            },


            currentUser ( state )
            {
                return state.currentUser;
            },

            currentUserId ( state )
            {
                return state.currentUserId;
            },

            userToken ( state )
            {
                return state.token;
            },

            currentPostReactions ( state )
            {
                return state.mainPostReactions;
            },

            mainContentType ( state )
            {
                return state.mainContentType;
            },

            mainContentId ( state )
            {
                return state.mainContentId;
            },

            mainPostReactions ( state )
            {
                return state.mainPostReactions;
            },

            isReportModalOpen ( state )
            {
                return state.reportModalOpen;
            },

            reportCommentId ( state )
            {
                return state.reportCurrentCommentId;
            },

            reportReasonId ( state )
            {
                return state.reportCurrentReasonId;
            },

            userReactions ( state )
            {
                return state.userReactions;
            },

            audienceMode ( state )
            {
                return state.audienceMode;
            },


            isCurrentlyUpdatingComments ( state )
            {
                return state.isCurrentlyUpdatingComments;
            },
        };


let actions =
        {

            async copydeck ( { commit } )
            {
                let response = await axios.get( "/endpoints/copydeck-comments" );


                commit( "copydeck", response.data );
            },





            async updateRelatedDataInStore ( { commit, state }, payload )
            {
                // console.log( 'payload', payload );
                const postType = state.mainContentType;
                const postId   = state.mainContentId;

                commit( "setCurrentlyUpdatingComments", true );

                let response;

                try
                {
                    response = await axios.get(`/endpoints/related/${postType}/${postId}?cachedOn=${state.relatedCachedOn}`);

                    commit( "setCurrentlyUpdatingComments", false );
                    commit( "updateRelatedDataInStore", response.data );
                }

                catch (e)
                {
                    commit( "setCurrentlyUpdatingComments", false );
                }


            },

            async userInfo ( { commit, state }, payload )
            {

                const { postType, postId } = payload;

                let response = await axios.get( "/endpoints/userinfo" );

                commit( "updateRelatedDataInStore", response.data );
            },


            async updateUserReactions ( { commit, state }, payload )
            {

                try
                {

                    let response = await axios.get( `/endpoints/user-reactions/${state.mainContentType}/${state.mainContentId}` );

                    commit( "updateUserReactions", response.data.data );
                }

                catch (e)
                {

                }
            },

            mainContentInfo ( { commit, state }, payload )
            {
                commit( "mainContentInfo", payload );
            },
        }


let mutations =
        {


            ready ( state )
            {
                state.ready = true;
            },


            copydeck ( state, payload )
            {
                state.copydeck = payload;
            },

            mainContentInfo ( state, payload )
            {

                state.mainContentType = payload.mainContentType;
                state.mainContentId   = payload.mainContentId;
                state.reactionsOnly   = payload.reactionsOnly;

                // console.log( 'state', state, payload );
            },

            reactionAdjusted (state, payload)
            {
                if (payload.postType === "posts")
                {
                    if (!state.mainPostReactions)
                    {
                        state.mainPostReactions = {};
                    }

                    if (!state.mainPostReactions[payload.id_reaction])
                    {
                        state.mainPostReactions[payload.id_reaction] = 0;
                    }

                    state.mainPostReactions[payload.id_reaction] += payload.quantity;

                    if (payload.quantity == -1)
                    {
                        //note when postType is post id_comment really mean id_post
                        state.userReactions = state.userReactions.filter( reaction => reaction.id_content != payload.id_comment && reaction.id_reaction !== payload.id_reaction );
                    }
                    else
                    {
                        state.userReactions.push({ id_content: payload.id_comment, id_reaction: payload.id_reaction });
                    }
                }
                else if (payload.id_comment_parent == 0)
                {
                    let comment = state.comments.find( comment => comment.id === payload.id_comment );

                    if (!comment?.reactions)
                    {
                        comment.reactions = {};
                    }

                    if (!comment.reactions[payload.id_reaction])
                    {
                        comment.reactions[payload.id_reaction] = 0;
                    }

                    comment.reactions[payload.id_reaction] += payload.quantity;


                    if (payload.quantity == -1)
                    {
                        state.userReactions = state.userReactions.filter( reaction => reaction.id_content != payload.id_comment && reaction.id_reaction !== payload.id_reaction );
                    }
                    else
                    {
                        state.userReactions.push({ id_content: payload.id_comment, id_reaction: payload.id_reaction });
                    }



                }
                else
                {
                    let comment = state.comments.find( comment => comment.id === payload.id_comment_parent );

                    if (!comment)
                        return;

                    let childComment = comment.child_comments.find( comment => comment.id === payload.id_comment );

                    if (!childComment?.reactions)
                    {
                        childComment.reactions = {};
                    }

                    if (!childComment.reactions[payload.id_reaction])
                    {
                        childComment.reactions[payload.id_reaction] = 0;
                    }

                    childComment.reactions[payload.id_reaction] += payload.quantity;

                    if (payload.quantity == -1)
                    {
                        state.userReactions = state.userReactions.filter( reaction => reaction.id_content != payload.id_comment && reaction.id_reaction !== payload.id_reaction );
                    }
                    else
                    {
                        state.userReactions.push({ id_content: payload.id_comment, id_reaction: payload.id_reaction });
                    }

                }
            },



            addNewComments ( state, payload)
            {
                if (!payload.skipAddNew)
                {
                    state.newComments.push(payload);
                }

                if (payload.id_comment_parent != 0)
                {
                    let comment = state.comments.find( comment => comment.id === payload.id_comment_parent );
                    comment.child_comments.unshift(payload);
                }
                else
                {
                    state.comments.unshift(payload);
                }
            },

            updateRelatedDataInStore ( state, payload )
            {
                let noChange = payload?.cache == "no-change";

                if (noChange)
                {
                    return;
                }

                let payloadComments = payload?.comments ?? [];

                if (state.newComments.length > 0)
                {
                    for (let i = 0; i < state.newComments.length; i++)
                    {
                        let newComment = state.newComments[i];

                        if (newComment.id_comment_parent == 0)
                        {
                            let exist = payloadComments.find( comment => comment?.newId === newComment?.newId );

                            if (!exist)
                            {
                                payloadComments.unshift(newComment);
                                state.newComments = state.newComments.filter( comment => comment?.newId !== newComment?.newId );
                            }
                        }
                        else
                        {
                            let parentComment = payloadComments.find( comment => comment.id === newComment.id_comment_parent );

                            if (parentComment)
                            {
                                let exist = parentComment.child_comments.find( comment => comment?.newId === newComment.newId );

                                if (!exist)
                                {
                                    parentComment.child_comments.unshift(newComment);
                                    state.newComments = state.newComments.filter( comment => comment?.newId !== newComment?.newId );
                                }
                            }
                        }
                    }
                }

                state.comments          = payloadComments;
                state.mainPostReactions = payload?.reactions ?? [];
                state.relatedCachedOn   = payload?.cachedOn ?? 0;

                // console.log( 'Updated updateRelatedDataInStore', payload );
            },

            authenticateUser ( state, data )
            {

                state.authenticated = true;
                state.token         = data.token;
                state.currentUser   = data.user;
                state.currentUserId = data.user.id;
                ////console.log('store mutator authenticateUser', data);
            },

            toggleComments ( state )
            {
                state.showComments = !state.showComments;
            },


            initialCommentsState ( state, payload )
            {
                state.showComments = payload;
            },

            forceShowComments ( state )
            {
                state.showComments = true;
            },


            closeReportingModal ( state )
            {
                state.reportModalOpen = false;
            },

            openReportingModal ( state )
            {
                state.reportModalOpen = true;
            },

            changeReportCommentId ( state, payload )
            {
                state.reportCurrentCommentId = payload;
            },

            changeReportReasonId ( state, payload )
            {
                state.reportCurrentReasonId = payload;
            },

            updateUserReactions ( state, payload )
            {
                state.userReactions = payload;
            },


            changeAudienceMode ( state, payload )
            {
                state.audienceMode = payload;
            },


            setLiveRefreshMode ( state, payload )
            {
                state.doLiveRefresh = payload;
            },


            setLiveRefreshModeFrequency ( state, payload )
            {
                state.liveRefreshFrequency = payload;
            },

            setCurrentlyUpdatingComments ( state, payload )
            {
                console.log("setCurrentlyUpdatingComments", payload)
                state.isCurrentlyUpdatingComments = payload;
            },
        }


export default createStore( { state, getters, actions, mutations } );

